// extracted by mini-css-extract-plugin
export default {"Content":"Layout_Content__+2+Rn","Alert":"Layout_Alert__K1+TV"};